import * as React from "react";
import GridCalendar from "./GridCalendar";

export const ProxyCalendar = ({ column, value, handleChange, disabled, tableSchema }) => (
	<GridCalendar
		value={value}
		onChangeValue={handleChange}
		disabled={column?.editable === false || !!disabled}
		isRanged={column?.isRanged}
		multipleProps={column?.extra?.multiple}
		isMultiple={column?.type === "RangedMultiCalendar" ?? false}
		tableSchema={tableSchema}
	/>
);
